import { render, staticRenderFns } from "./SendDocumentDetailTab.vue?vue&type=template&id=44edcf36&scoped=true&lang=pug"
import script from "./SendDocumentDetailTab.vue?vue&type=script&lang=ts"
export * from "./SendDocumentDetailTab.vue?vue&type=script&lang=ts"
import style0 from "./SendDocumentDetailTab.vue?vue&type=style&index=0&id=44edcf36&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44edcf36",
  null
  
)

export default component.exports